<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qUa3Bn/tc-custom/9781429945752.jpg?1744273752675" alt="This image is the cover for the book Day Dixie Died"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Day Dixie Died
      </h1>
      <p class="bookDescription body article font2">
        <b>A history of one of the most important battles waged on American soil that changed the course of the Civil War and helped decide a presidential election.</b><br/><br/>In the North, a growing peace movement and increasing criticism of President Abraham Lincoln’s conduct of the war threatened to halt US war efforts to save the Union. On the morning of July 22, 1864, Confederate forces under the command of General John Bell Hood squared off against the Army of the Tennessee led by General James B. McPherson just southeast of Atlanta.<br/><br/>Having replaced General Joseph E. Johnston just four days earlier, Hood had been charged with the duty of reversing a Confederate retreat and meeting the Union army head on. The resulting Battle of Atlanta was a monstrous affair fought in the stifling Georgia summer heat. During it, a dreadful foreboding arose among the Northerners as the battle was undecided and dragged on for eight interminable hours. Hood’s men tore into US forces with unrelenting assault after assault. Furthermore, for the first and only time during the war, a US army commander was killed in battle, and in the wake of his death, the Union army staggered. Dramatically, General John “Black Jack” Logan stepped into McPherson’s command, rallied the troops, and grimly fought for the rest of the day. In the end, ten thousand men—one out of every six—became casualties on that fateful day, but the Union lines had held.<br/><br/>Having survived the incessant onslaught from the men in grey, Union forces then placed the city of Atlanta under siege, and the city’s inevitable fall would gain much-needed, positive publicity for Lincoln’s reelection campaign against the peace platform of former Union general George B. McClellan.<br/><br/>Renowned Civil War historian Gary Ecelbarger is in his element here, re-creating the personal and military dramas lived out by generals and foot soldiers alike, and shows how the battle was the game-changing event in the larger Atlanta Campaign and subsequent March to the Sea that brought an eventual end to the bloodiest war in American history. This is gripping military history at its best and a poignant narrative of the day Dixie truly died.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gary Ecelbarger
      </h2>
      
      <p class="authorDescription body article"><P>GARY ECELBARGER is a Civil War historian and has conducted several tours of the Atlanta Campaign battlefields. He has written or co-written eight books, including <I>The Great Comeback: How Abraham Lincoln Beat the Odds to Win the 1860 Republican Nomination</I>, along with biographies of Civil War generals "Black Jack" Logan and Frederick W. Lander and military histories of the Shenendoah Valley campaign and the First Battle of Kernstown. He lives in northern Virginia with his wife and three children.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7576bd2d